import { render } from "./ReferenzenPage.vue?vue&type=template&id=355a76e6"
import script from "./ReferenzenPage.vue?vue&type=script&lang=js"
export * from "./ReferenzenPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__